// packages/components/src/admin/payments/InvoiceList.tsx
import React from 'react';
import { useListInvoices } from '@dopomogai/agent-kit';
import { Card, Spinner, Alert, Button, Icon } from '@dopomogai/ui';
import type { InvoiceLog } from '@dopomogai/api-client';
import { InvoiceListItem } from './InvoiceListItem';

// Define props for the component
interface InvoiceListProps {
    onDuplicate: (invoice: InvoiceLog) => void;
}

export const InvoiceList: React.FC<InvoiceListProps> = ({ onDuplicate }) => {
  const { invoices, isLoading, error, refetch } = useListInvoices();

  if (error) {
    return <Alert type="error" title="Failed to load invoices" message={error.message} />;
  }

  return (
    <Card 
        title="Invoice Management"
        actionButton={
            <Button 
                text="Refresh List" 
                variant="secondary" 
                size="sm" 
                onClick={() => refetch()}
                disabled={isLoading}
            />
        }
    >
        <div className="font-bold grid grid-cols-12 gap-4 p-3 bg-slate-100 border-b-2 border-slate-200 text-sm text-slate-600 uppercase">
            <div className="col-span-1"></div> {/* Spacer for expand icon */}
            <div className="col-span-5">Details / Destination</div>
            <div className="col-span-2">Status</div>
            <div className="col-span-2">Amount</div>
            <div className="col-span-2 text-right">Actions</div>
        </div>

        {isLoading ? (
            <div className="flex justify-center items-center p-16">
                <Spinner text="Loading invoices..." />
            </div>
        ) : (
            <div>
                {invoices.length === 0 ? (
                    <p className="text-center text-slate-500 p-8">No invoices found.</p>
                ) : (
                    invoices.map(invoice => (
                        <InvoiceListItem 
                            key={invoice.id} 
                            invoice={invoice} 
                            onActionSuccess={refetch}
                            onDuplicate={() => {
                                onDuplicate(invoice);
                            }}
                        />
                    ))
                )}
            </div>
        )}
    </Card>
  );
};